// Packages

// Components
import { BlockedUsers } from "./BlockedUsers/BlockedUsers";

// Logic

// Context

// Services

// Styles

// Assets

export const Blocked = () => {
	return (
		<div className='settings-subpage'>
			<BlockedUsers />
		</div>
	);
};
